/* Cappafe — "Recommended for your vehicle" quick add (cart drawer + cart page).
   Markup: snippets/cappafe-vehicle-recs.liquid. Adds the product, then re-renders the cart drawer
   through the theme's own renderContents so the list refreshes for the new cart. */
(function () {
  if (window.__cfVehicleRecs) return;
  window.__cfVehicleRecs = true;

  function track(item) {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cf_vehicle_rec_add', item: item }); } catch (e) {}
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-cf-vr-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (btn.disabled) return;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '…';

    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.querySelector('cart-items:not(cart-drawer-items)') && /\/cart\/?$/.test(location.pathname);
    var body = new FormData(form);
    if (drawer && !onCartPage && drawer.getSectionsToRender) {
      body.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      body.append('sections_url', location.pathname);
    }
    var card = form.closest('.cf-vr__card');
    var name = card && card.querySelector('.cf-vr__name') ? card.querySelector('.cf-vr__name').textContent.trim() : '';

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'add');
        track(name);
        if (onCartPage) { location.reload(); return; }
        if (drawer && res.sections && drawer.renderContents) {
          try { drawer.renderContents(res, true); return; } catch (renderError) { /* drawer not ready: fall back to reload */ }
        }
        location.reload();
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        var msg = form.querySelector('.cf-vr__err');
        if (!msg) { msg = document.createElement('span'); msg.className = 'cf-vr__err'; form.appendChild(msg); }
        msg.textContent = (err && err.message && err.message !== 'add') ? err.message : 'Could not add, please try again';
      });
  });
})();
